import { render, staticRenderFns } from "./ChainForm.vue?vue&type=template&id=b96d8f90&scoped=true"
import script from "./ChainForm.vue?vue&type=script&lang=js"
export * from "./ChainForm.vue?vue&type=script&lang=js"
import style0 from "./ChainForm.vue?vue&type=style&index=0&id=b96d8f90&prod&lang=scss"
import style1 from "./ChainForm.vue?vue&type=style&index=1&id=b96d8f90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96d8f90",
  null
  
)

export default component.exports